import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  UPLOAD_PICTURE_FEATURE_KEY,
  UploadPictureState,
} from './upload-picture.reducer';

export const getUploadPictureState = createFeatureSelector<UploadPictureState>(
  UPLOAD_PICTURE_FEATURE_KEY,
);

export const isUploadingPicture = createSelector(
  getUploadPictureState,
  (state: UploadPictureState) => state.uploading,
);

export const isUploadedPicture = createSelector(
  getUploadPictureState,
  (state: UploadPictureState) => state.uploaded,
);

export const isVerifying = createSelector(
  getUploadPictureState,
  (state: UploadPictureState) => state.verifying,
);

export const isVerified = createSelector(
  getUploadPictureState,
  (state: UploadPictureState) => state.verified,
);

export const getUploadPictureError = createSelector(
  getUploadPictureState,
  (state: UploadPictureState) => state.error,
);
